import React from "react";
import { Oval } from "react-loader-spinner";

function Loader({ size, color }) {
  return (
    <div className="absolute w-full bottom-0 top-0 overflow-hidden flex flex-1 items-center justify-center">
      <Oval
        height={size || 30}
        width={size || 30}
        color={color || "red"}
        wrapperStyle={{}}
        wrapperClass=""
        visible={true}
        ariaLabel="oval-loading"
        // secondaryColor="red"
        strokeWidth={2}
        strokeWidthSecondary={2}
      />
    </div>
  );
}

export default Loader;
